import React, { useState, useEffect } from "react";
import Icon from "components/Elements/Icon/Icon.tsx";

const FormBuilderEditOptionElement = ({
  i,
  optionsList,
  setOptionsList,
  item,
  updateOptionsFunction,
  removeOption,
}) => {
  const [focusOption, setFocusOption] = useState({ value: null, index: null });
  const [isUpdateOptions, setIsUpdateOptions] = useState(false);

  const handleChangeOption = (e, index) => {
    let tempOptions = [...optionsList];
    tempOptions[index] = e;
    setOptionsList(tempOptions);
  };

  const handleBlurOption = (e, index) => {
    if (index === focusOption.index) {
      if (e !== focusOption.value) {
        setIsUpdateOptions(true);
      }
    }
  };

  useEffect(() => {
    if (isUpdateOptions) {
      updateOptionsFunction();
      setIsUpdateOptions(false);
    }
  }, [isUpdateOptions]);

  return (
    <div className="option-line">
      <div className="option-content">
        <div className="option-image"></div>
        <div className="option-label">
          <input
            type="text"
            value={item}
            onChange={(e) => handleChangeOption(e.target.value, i)}
            onFocus={(e) => setFocusOption({ value: e.target.value, index: i })}
            onBlur={(e) => handleBlurOption(e.target.value, i)}
          />
        </div>
      </div>
      {i > 0 ? (
        <div className="option-remove" onClick={() => removeOption(item)}>
          <Icon name="trash-solid-b" />
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default FormBuilderEditOptionElement;
